<script>
export default {}
</script>

<template>
  <h1><slot></slot></h1>
</template>

<style scoped>
h1 {
  font-size: 24px;
  margin-bottom: 20px;
}
</style>